var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrongicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6802 2.31486C54.594 -0.771623 49.5902 -0.77162 46.504 2.31487L30.0001 18.8202L13.4961 2.31487C10.4099 -0.77162 5.40611 -0.771623 2.31988 2.31486C-0.766343 5.40135 -0.766344 10.4055 2.31988 13.492L18.8238 29.9974L2.31467 46.508C-0.771557 49.5944 -0.771556 54.5986 2.31467 57.6851C5.4009 60.7716 10.4047 60.7716 13.4909 57.6851L30.0001 41.1745L46.5092 57.6851C49.5955 60.7716 54.5992 60.7716 57.6855 57.6851C60.7717 54.5986 60.7717 49.5944 57.6855 46.508L41.1763 29.9974L57.6802 13.492C60.7665 10.4055 60.7665 5.40135 57.6802 2.31486Z",
    fill: "#FF4949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongicon);
export default __webpack_public_path__ + "static/media/wrongicon.c54944ca8add642c73093282d43650c2.svg";
export { ForwardRef as ReactComponent };